import type React from 'react';
import dayjs from 'dayjs';

export const FormattedDateTime: React.VFC<{ date: Date | string }> = ({ date }) => {
  const parsedDate = dayjs(date);
  if (!parsedDate.isValid()) return <>Invalid Date</>;
  const formattedDate = new Intl.DateTimeFormat('cs-CZ', { dateStyle: 'medium', timeStyle: 'short' }).format(
    parsedDate.toDate(),
  );
  return <div>{formattedDate}</div>;
};
